export default {
  "hierarchy": {
    "small": [
      "portal-small"
    ],
    "dialog": [
      "portal-dialog"
    ],
    "inPlaceAttributeEditor": [
      "portal-inPlaceAttributeEditor"
    ],
    "contextMenu": [
      "portal-contextMenu"
    ],
    "dialogLarge": [
      "portal-dialog",
      "portal-dialogLarge"
    ]
  },
  "props": {
    "default": {
      "animation": "slideFromTop",
      "position": ""
    },
    "small": {
      "animation": "slideFromTop",
      "position": "top"
    },
    "dialog": {
      "animation": "slideFromTop",
      "position": "center"
    },
    "inPlaceAttributeEditor": {
      "animation": "slideFromTop",
      "position": "top"
    },
    "contextMenu": {
      "animation": "slideFromTop",
      "position": "top"
    },
    "dialogLarge": {
      "animation": "slideFromTop",
      "position": "top"
    }
  }
}